<script lang="ts">
  export let totalOpportunities: number = 0;
  export let fullySynced: number = 0;
  export let nonAwsDeals: number = 0;
  export let showNonAwsDeals: boolean = false;
  export let apiError: string = "";
  export let lastSyncTime: string = "";

  const formatRelativeTime = (isoString: string) => {
    if (!isoString || !isoString.trim()) return "—";
    try {
      const date = new Date(isoString);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffMins = Math.floor(diffMs / 60000);

      if (diffMins < 1) return "just now";
      if (diffMins < 60) return `${diffMins} min ago`;
      const diffHours = Math.floor(diffMins / 60);
      if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
      const diffDays = Math.floor(diffHours / 24);
      return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
    } catch {
      return "recently";
    }
  };
</script>

<div
class="bg-[#1b1e2e]/70 border border-white/10 rounded-xl p-6 relative transition-all w-full h-full box-border flex flex-col justify-between border-l-4 border-[#ff9900] hover:shadow-lg hover:border-white/20">
  <header class="flex items-center gap-3 mb-4 min-h-8">
    <span class="shrink-0 text-2xl leading-none" aria-hidden="true">🟠</span>
    <h4 class="flex-1 min-w-0 m-0 text-[1.125rem] font-bold text-white">HubSpot</h4>
    <div
    class="px-3 py-1 bg-[rgba(255,153,0,0.2)] text-[#ffa500] rounded-2xl text-xs font-semibold border border-[rgba(255,153,0,0.3)]"
  >
    Source
  </div>
  </header>

  <div class="h-px bg-white/10 my-4" />

  <div class="flex flex-col gap-3">
    <div class="flex justify-between items-center text-sm">
      <span class="text-white/60 font-medium">Total:</span>
      <span class="text-white font-semibold flex items-center gap-2">{totalOpportunities}</span>
    </div>
    <div class="flex justify-between items-center text-sm">
      <span class="text-white/60 font-medium">Synced:</span>
      <span class="text-green-500 font-semibold flex items-center gap-2">{fullySynced}</span>
    </div>
    <div class="flex justify-between items-center text-sm">
      <span class="text-white/60 font-medium">Pending:</span>
      <span class="text-amber-500 font-semibold flex items-center gap-2">
        {Math.max(0, totalOpportunities - fullySynced)}
      </span>
    </div>
    {#if showNonAwsDeals}
      <div class="flex justify-between items-center text-sm">
        <span class="text-white/60 font-medium">Non-AWS:</span>
        <span class="font-semibold flex items-center gap-2" style="color: #93c5fd;">{nonAwsDeals}</span>
      </div>
    {/if}
    <div class="flex justify-between items-center text-sm">
      <span class="text-white/60 font-medium">API:</span>
      <span
        class={`font-semibold flex items-center gap-2 ${apiError ? "text-red-500" : "text-green-500"}`}
        title={apiError}
      >
        {apiError ? "Error" : "OK"}
      </span>
    </div>
  </div>

  <div class="flex justify-between items-center mt-4 pt-4 border-t border-white/10 text-[0.813rem]">
    <span class="text-white/50">Last Pull</span>
    <span class="text-white font-semibold">{formatRelativeTime(lastSyncTime)}</span>
  </div>
</div>
